import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './components/contexts/LanguageContext';
import NotFound from './components/NotFound';
import ScrollToTop from './components/ScrollToTop';
import { GoalProvider } from './components/contexts/GoalContext.tsx';
import { HelmetProvider } from 'react-helmet-async';
import '@fontsource/noto-sans-arabic/400.css';
import GitGenesLanding from './pages/GitGenesLanding.jsx';

const AuthWrapper = ({ children }) => {
  return children;
};

function App() {
  return (
    <HelmetProvider>
    <LanguageProvider>
      <GoalProvider>
      <LanguageProvider>
        <Router>
          <AuthWrapper>
            <ScrollToTop />
            <div>
              <main >
                <Routes>
                  {/* Public routes */}
  
                   <Route path="/" element={<GitGenesLanding />} />
                  {/* Catch all route */}
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </main>
            </div>
          </AuthWrapper>
        </Router>
        </LanguageProvider>
      </GoalProvider>
    </LanguageProvider>
        </HelmetProvider>

  );
}

export default App;